import styled, {css} from "styled-components";
import {VFlex} from "components/_defaultComponents/Flex/VFlex";
import {lastTriedInvoicesTheme} from "../components/lastTriedInvoices/LastTriedInvoices.styles";

export const PaymentsPageContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    background: #fff;
`;

export const PaymentsFilterCard = styled.div`
    width: 100%;
    background: #f5f5f5;
    border-radius: 8px;
    margin-bottom: 16px;
`;

export const FilterSection = styled(VFlex)`
    width: 100%;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 16px;
    padding: 16px 20px 8px;
    margin-bottom: 0;

    .filter-item {
        flex: 1 1 200px;
        min-width: 200px;
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .filter-item h5 {
        margin: 0 0 4px 0;
        font-weight: 500;
        font-size: 14px;
        color: #333;
    }

    @media (max-width: 768px) {
        .filter-item {
            min-width: 100%;
        }
    }
`;

export const FiltersSubRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    justify-content: space-between;
    gap: 16px;
    padding: 0 20px 16px;
    width: 100%;
    box-sizing: border-box;

    .filters-subrow-left {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-end;
        gap: 16px;
        flex: 1 1 auto;
        min-width: 200px;
    }

    .filters-subrow-right {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 16px;
        flex-wrap: wrap;
        margin-left: auto;
    }

    .filter-item--checkbox {
        display: flex;
        align-items: center;
        flex: 0 1 auto;
        min-width: auto;
        padding-bottom: 2px;
    }

    .filter-item--date {
        flex: 1 1 280px;
        min-width: 260px;
        max-width: 420px;
    }

    @media (max-width: 768px) {
        .filter-item--date {
            min-width: 100%;
            max-width: none;
        }
    }
`;

export const MakePaymentSection = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 24px;
    flex-wrap: wrap;
    padding: ${({embedded}) => (embedded ? "0" : "24px 20px")};
`;

export const AmountPayable = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 18px;
    font-weight: 600;
    color: #333;

    .amount-icon {
        color: #52c41a;
        font-size: 20px;
    }
`;

export const MakePaymentButton = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 20px;
    font-size: 14px;
    font-weight: 500;
    color: #fff;
    background: #52c41a;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    transition: background 0.2s;

    &:hover {
        background: #389e0d;
    }
`;

export const TableSection = styled.div`
    width: 100%;
    background: #fff;
    border-radius: 8px;
    overflow: hidden;

    .ant-table {
        font-size: 14px;
    }

    .ant-table-thead > tr > th {
        background: #fafafa;
        font-weight: 600;
        color: #333;
    }

    .ant-table-tbody > tr > td {
        border-bottom: 1px solid #f0f0f0;
    }

    .ant-table-expanded-row > td {
        background: ${lastTriedInvoicesTheme.expandedRowBackground} !important;
        padding: 12px !important;
    }
`;

export const StatusCell = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    flex-wrap: nowrap;
    max-width: 100%;
`;

export const DescriptionText = styled.span`
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-word;
`;

export const StatusBadge = styled.span`
    display: inline-block;
    padding: 4px 12px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 500;
    color: #fff;
    background: #faad14;
    white-space: nowrap;
    line-height: 1.4;

    ${({status}) =>
        status === "approved" &&
        css`
            background: #52c41a;
        `}

    ${({status}) =>
        status === "canceled" &&
        css`
            background: #ff4d4f;
        `}

    ${({status}) =>
        status === "failed" &&
        css`
            background: #8c8c8c;
        `}

    ${({status}) =>
        status === "processing" &&
        css`
            background: #1890ff;
        `}

    ${({status}) =>
        status === "created" &&
        css`
            background: #1890ff;
        `}

    ${({status}) =>
        status === "invoiceApproved" &&
        css`
            background: #52c41a;
        `}
    ${({status}) =>
        status === "waitingForFinanceApprove" &&
        css`
            background: #1890ff;
        `}
`;
